import React, { useContext } from "react";
import { Container } from "components/Container";
import { VisorPdf } from "../VisorPdf";
import { ModalFirmar } from "../ModalFirmar";
import { ModalExito } from "../ModalExito";
import { ListaDocumentos } from "./componentes/ListaDocumentos";
import { VisorFormulario } from "./componentes";
import { ModalConsultar } from "../VisorPdf/Header/ModalConsultar";
import { useAtom } from "jotai";
import { ModalMensajeAlerta } from "../ModalMensajeAlerta";
import { ModalSubirArchivo } from "../ModalSubirArchivo/ModalSubirArchivo";
import {
	loadingPdfAtom,
} from "pages/v3/mis-pendientes/componentes/MisDocumentosWeb/MisDocumentosWebStorage";
import { ModalValidarDeclaracion } from "../ModalValidarDeclaracion";
import { ModalRegistrarAsistencia } from "../../common/components";
import { ModalConsentimientoDatos } from "../ModalConsentimientoDatos";
import { MisDocumentosContext } from "context/v3/MisDocumentosContext";
import { SecurityContext } from "context/SecurityContextProvider";
import { aplicaAgrupacionOnboarding } from "pages/v3/mis-pendientes/common/utils/agruparPorOnboarding";

const MisDocumentosWeb = () => {
	const [loadingPdf] = useAtom(loadingPdfAtom);
	const { documentos } = useContext(MisDocumentosContext);
	const { getUsuarioAutenticado } = useContext(SecurityContext);

	// Explomin con documentos agrupados por onboarding: cada grupo ya es una card, no se envuelve en otra
	const agrupado = aplicaAgrupacionOnboarding(getUsuarioAutenticado()) && (documentos || []).some((d) => d.onboardingNombre);
	return (
		<Container titulo="Mis Pendientes" sinCard={agrupado}>
			<ListaDocumentos />
			<VisorFormulario loadingPdf={loadingPdf} />
			<VisorPdf />
			<ModalFirmar />
			<ModalValidarDeclaracion />
			<ModalExito />
			<ModalSubirArchivo />
			<ModalConsultar />
			<ModalMensajeAlerta />
			<ModalRegistrarAsistencia />
			<ModalConsentimientoDatos />
		</Container>
	);
};

export default MisDocumentosWeb;
